import HashLoader from "react-spinners/HashLoader";
import { COLORS } from "../../../Constants/Colors/colors";

export default function Hash({ color }) {
  return <HashLoader size={22} color={color || COLORS.WHITE} />;
}
